// third-party
import { FormattedMessage } from "react-intl";
import help from "../assets/icons/support.svg";

const icons = {
  Support: () => <img src={help} alt="help icon" />,
};

// Get assistance URL
const getAssistanceUrl = () => {
  let landingUrl = import.meta.env.VITE_LANDING_URL;
  if (!landingUrl && typeof window !== 'undefined') {
    landingUrl = `${window.location.protocol}//${window.location.hostname}`;
  }
  const locale = typeof window !== 'undefined' ? (localStorage.getItem('i18nextLng') || 'fr') : 'fr';
  return `${landingUrl}/${locale}/assistance`;
};

const Support = {
  id: "Support",
  title: <FormattedMessage id="Support" defaultMessage="Support" />,
  type: "group",
  url: getAssistanceUrl(),
  icon: icons.Support,
  external: true,
  target: true,
};

export default Support;
